export default  {
  name: 'area-checkbox',
  model: {
    prop: 'value',
    event: 'selectedAreaChanged',
  },
  props: [
    'areas',
    'selected',
    'type',
    'baseId',
  ],
  mounted() {

  },
  data() {
    return {
      value: [],
      areaActiveS: [],
      locSelected: '',
    };
  },
  methods: {
    onClick(index, item) {
      this.areaActiveS[index].active = !(this.areaActiveS[index].active);
      if (this.type == 'radio' ) {
        // let checkbox = document.getElementById(this.baseId + item.id);
        // checkbox.checked = true;
        // this.$emit('selectedAreaChanged', [item]);
      }
      if (this.type == 'checkbox') {
        // let checkbox = document.getElementById(this.baseId + item.id);
        // // checkbox.checked = true;
        // this.$emit('selectedAreaChanged', [item]);
      }
    },
    selectedAreaChanged(area) {
      if (this.type == 'radio') {
        this.value = area;
        this.$emit('selectedAreaChanged', this.value);
      }
      if (this.type == 'checkbox') {
        this.onCheck(area);
      }
    },
    onCheck(area) {
      if (this.type == 'checkbox') {
        for (let i = 0; i < area.length; i++) {
          const checked = document.getElementById(this.baseId + area[i].id).checked;
          if (checked && !(this.value.indexOf(area[i]) + 1)) {
            this.value.push(area[i]);
          }
        }
        for (let i = 0; i < this.value.length; i++) {
          const checked = document.getElementById(this.baseId + this.value[i].id).checked;
          if (!checked) {
            this.value.splice(i, 1);
            i--;
          }
        }
        this.$emit('selectedAreaChanged', this.value);
        // this.value = area;
      }
      if (this.type == 'radio') {
        for (let i = 0; i < area.length; i++) {
          const checked = document.getElementById(this.baseId + area[i].id).checked;
          if (checked && !(this.value.indexOf(area[i]) + 1)) {
            this.value.push(area[i]);
          }
        }
        for (let i = 0; i < this.value.length; i++) {
          const checked = document.getElementById(this.baseId + this.value[i].id).checked;
          if (!checked) {
            this.value.splice(i, 1);
            i--;
          }
        }
        this.$emit('selectedAreaChanged', this.value);
        // this.value = area;
      }
    },
    updateCheckBox() {
      if (!this.selected) return;
      for (var i = 0; i < this.selected.length; i++) {
        let elem = document.getElementById(this.baseId + this.selected[i].id)
        if (elem) {
          elem.checked = true;
        }
      }
    },

  },
  computed: {

  },
  created() {
    // this.value = [];
    this.value = this.selected;
    for (var i = 0; i < this.areas.length; i++) {
      // this.areas[i].active = false;
      // console.log('add');
      this.areaActiveS.push({ active: false });
    }
    this.updateCheckBox();
  },
  watch: {
    selected(val) {
      this.value = this.selected;
      this.updateCheckBox();
    },
    areas() {
      for (let i = 0; i < this.areas.length; i++) {
        this.areaActiveS.push({ active: false });
      }
    },
  },
};




// WEBPACK FOOTER //
// ./src/components/areaCheckbox/areaCheckbox.component.js